<template>
  <div class="private-area" :class="{'has-sidebar': sidebarOpened}">

    <sidebar :show="sidebarOpened"
      v-on:showDashboardModal="openDashboardModal"></sidebar>

    <router-view class="router-view"></router-view>

    <dashboard-modal v-if="showDashboardModal"
		  @save="connectDashboardSave"
		  @close="closeDashboardModal">
    </dashboard-modal>
  </div>
</template>
<script>
import {Sidebar} from 'components/layouts/';
import {DashboardModal} from 'components/modals/';

export default {
    components: {
	    Sidebar: Sidebar,
	    DashboardModal
    },
    data () {
      return {
        showDashboardModal: false,
        sidebarOpened: true
      };
     },
    created () {
      BUS.$on('toggleSidebar', () => {
        this.sidebarOpened = !this.sidebarOpened;
      });
    },
    methods: {
      openDashboardModal(thingType) {
        this.dashboardThingType = thingType;
        this.showDashboardModal = true;
      },
      closeDashboardModal() {
        this.dashboardThingType = null;
        this.showDashboardModal = false;
      },
      connectDashboardSave (dashboard) {
        // Updating Sidebar LiST
        BUS.$emit('refreshDashboardsList');
        // redirecting onCreate
        this.$router.push({ name: 'user-dashboard-detail',
                            force: true,
                            params: { id: dashboard.id }
        });
        // closing modal
        this.closeDashboardModal();
      }
    }
  };
</script>
<style scoped>
  /** Footer */
 footer {
   height: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?e40377bc